import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { LoadingIndicatorService } from '../../services/loading-indicator.service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false,
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
  isLoading = false
  private subscription!: Subscription

  constructor(private loadingIndicatorService: LoadingIndicatorService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscription = this.loadingIndicatorService.isLoading$.subscribe((value: boolean) => {
      this.isLoading = value
      this.cdr.detectChanges()
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
